import { ActionStore, NavigationStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';

const initialState: NavigationStore = {
  active: '',
  icon: '',
  menu: [],
  showPageTitle: true,
};

const reducer = (
  state = initialState,
  action: ActionStore<NavigationStore>,
): NavigationStore => {
  switch (action.type) {
    case Reducers.SET_ACTIVE_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
